// 彈窗類浮層開啟期間，把頁面本體 #root 設成 inert：背景 Tab 不到、點不到（焦點鎖定）。
// 為什麼不用原生 <dialog> showModal：它會把彈窗以外的元素全部變 inert，掛在 body 上的下拉、Tooltip、
// flatpickr 日曆也一起點不到，還會壓過手機版 loading 的疊放順序（ROADMAP #12）。
// 浮層本身是 Portal 到 body、不在 #root 裡，所以不受影響。
// 疊窗：各浮層用 layerRef 交出自己的容器（Dialog 卡片／Drawer 面板），開新一層時把下一層的容器也設 inert，
//   關掉最上層再還原下一層（舊版 ConfirmDialog 的 trapFocus 等價保護）。只動堆疊裡的容器，不碰 body 其他子元素：
//   彈窗內的下拉、日曆也 Portal 在 body，一律掃 body 會把它們一起鎖掉。
// 關閉時把焦點還給開啟前的元素（通常是觸發按鈕）。
import { useEffect } from 'react'
import { focusBeforeOpen } from './usePanelFocus'

// 開啟中的浮層，最後一個是最上層；el 為該層容器（沒傳 layerRef 時為 null，只參與 #root 計數）
// 命名別用 daisyUI 元件名（s-t-a-c-k 等）：Tailwind 會掃到這個字產生多餘 CSS，跟舊版不一致
const inertLayers = []

export function useInertBackground(active, layerRef) {
  useEffect(() => {
    if (!active) return
    const root = document.getElementById('root')
    const previous = focusBeforeOpen(layerRef?.current)
    const entry = { el: layerRef?.current ?? null }
    const below = inertLayers[inertLayers.length - 1]
    if (below?.el) below.el.inert = true
    if (inertLayers.length === 0 && root) root.inert = true
    inertLayers.push(entry)
    return () => {
      const i = inertLayers.indexOf(entry)
      const wasTop = i === inertLayers.length - 1
      inertLayers.splice(i, 1)
      if (wasTop) {
        const top = inertLayers[inertLayers.length - 1]
        if (top?.el) top.el.inert = false
      }
      if (inertLayers.length === 0 && root) root.inert = false
      // 開啟前的元素還在畫面上才還原（例如列表重新整理後按鈕可能已經不在了）；先解除下層 inert 才聚焦得到
      if (previous instanceof HTMLElement && previous.isConnected) previous.focus()
    }
    // layerRef 是 ref 物件，參照固定
  }, [active, layerRef])
}
